import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase.js'
import { apiFetch } from '../lib/api.js'
import { pageBg as podiumBg } from '../lib/images'

export default function ShareRedirectPage() {
  const { deckId } = useParams()
  const navigate = useNavigate()
  const [status, setStatus] = useState('loading')
  const [error, setError] = useState('')

  useEffect(() => {
    async function handleShare() {
      // 1. Récupère les infos du deck (fonctionne même pour les decks privés)
      let deck
      try {
        deck = await apiFetch(`/api/share/deck/${deckId}`)
      } catch {
        setStatus('error')
        setError('Ce quiz n\'existe pas ou a été supprimé.')
        return
      }

      // 2. Vérifie si l'utilisateur est connecté
      const { data: { user } } = await supabase.auth.getUser()

      if (user) {
        // Utilisateur connecté : enregistre le partage et redirige vers la home
        try {
          await apiFetch('/api/share/add', {
            method: 'POST',
            body: JSON.stringify({ deck_id: deckId }),
          })
        } catch {
          // Erreur non bloquante — on redirige quand même
        }
        navigate('/home', { replace: true, state: { toastMessage: `"${deck.titre}" ajouté à tes quiz partagés !` } })
      } else {
        // Non connecté : sauvegarde en localStorage et redirige vers login
        localStorage.setItem('kart_pending_share', JSON.stringify({ deckId, deckTitle: deck.titre }))
        navigate('/login', { replace: true })
      }
    }

    handleShare()
  }, [deckId, navigate]) // eslint-disable-line react-hooks/exhaustive-deps

  const bgStyle = { backgroundImage: `url(${podiumBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }

  return (
    <div className="min-h-screen flex items-center justify-center" style={bgStyle}>
      <div className="bg-gray-900/80 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center space-y-4 max-w-sm w-full mx-4">
        {status === 'error' ? (
          <>
            <div className="text-4xl">😕</div>
            <p className="text-white font-medium">{error}</p>
            <button
              onClick={() => navigate('/')}
              className="text-white/60 hover:text-white text-sm transition"
            >
              ← Retour à l'accueil
            </button>
          </>
        ) : (
          <>
            <svg className="animate-spin h-8 w-8 text-white/70 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
            </svg>
            <p className="text-white/70 text-sm">Chargement…</p>
          </>
        )}
      </div>
    </div>
  )
}
